import Notification from './Notification.js';

export default class BrazeContentCardNotification extends Notification {
    static createFromBrazeCard(card) {
        return new BrazeContentCardNotification(
            card.id,
            card.Wc,
            card.title,
            Date.parse(card.created),
            card.url,
            card.linkText || 'Read More',
            card.description,
            card.imageUrl,
        );
    }

    static fetch(category) {
        const cards = window.braze?.getCachedContentCards()?.cards ?? [];
        return cards
            .filter(card =>
                Date.parse(card.expiresAt) > Date.now() &&
                card.extras?.tier === 'premium' &&
                card.extras?.ad_type === 'notification_bell' &&
                card.extras?.category === category
            )
            .map(card => BrazeContentCardNotification.createFromBrazeCard(card));
    }
}
